import React from 'react';
import { roundCurrency } from '../../../Common/Helper';
import Reorder from '../Reorder';
import Duplicate from '../Duplicate';
import { Progress, MobileProgressBar } from '../Progress';

const progresses = ['Ready to Print', 'Printed', 'Shipped'];
const designServiceProgresses = ["Design in Progress", "Design Completed & Shipped"];
const ephotobookStandaloneProgresses = ['Processing Order', 'Completed'];

const OrderItemProject = (props) => {
  const {
    separator = '',
    id = '',
    currency = '',
    quantity = '',
    price = '',
    status = '',
    trackingUrl = '',
    displayOptions: {
      duplicate = false,
      reorder = false,
      trackingStatus = false,
    } = {},
    designServiceStatus = '',
    isDesignService = false,
    isEphotobookStandalone = false
  } = props;

  const completedIndex = progresses.findIndex(progressLevel => status === progressLevel);
  const dsStatus = designServiceStatus === "Design Completed" ? "Design Completed & Shipped" : designServiceStatus;
  const dsCompletedIndex = designServiceProgresses.findIndex(progressLevel => dsStatus === progressLevel);
  const ephotobookStandaloneCompletedIndex = ['Cancelled', 'Completed'].includes(status)
    ? ephotobookStandaloneProgresses.findIndex(progressLevel => status === progressLevel)
    : 0;
  const isTrackButtonEnabled = completedIndex === progresses.length - 1;

  return (
    <div>
      {id > 0 && separator}
      <div className='d-lg-flex justify-content-between'>
        <div className='col-auto px-0 d-flex flex-column align-items-center align-items-lg-start'>
          <div className='mt-3'>
            {
              trackingStatus && !isDesignService && reorder && <Reorder {...props}/>
            }
          </div>
          <div className='mt-3'>
            {
              trackingStatus && !isDesignService && duplicate && <Duplicate {...props}/>
            }
          </div>
        </div>
        {
          trackingStatus &&
          (!isEphotobookStandalone
          ? <div className='d-lg-none col-12 mt-4 mb-3'>
            <MobileProgressBar {...props} progresses={progresses} completedIndex={completedIndex}/>
            <p className='text-primary text-center'>{progresses[completedIndex]}</p>
            {(completedIndex >= progresses.length - 1) &&
            <div className='text-center'>
              <button
                type="button"
                className="btn btn-outline-primary btn-sm mx-1">
                Track
              </button>
            </div>
            }
          </div>
          : <div className='d-lg-none col-12 mt-4 mb-3'>
            <MobileProgressBar {...props} progresses={ephotobookStandaloneProgresses} completedIndex={ephotobookStandaloneCompletedIndex}/>
            <p className='text-primary text-center'>{ephotobookStandaloneProgresses[ephotobookStandaloneCompletedIndex]}</p>
          </div>)
        }
        <div className='col px-0 px-lg-3 justify-content-center justify-content-lg-start'>
          <Description {...props}/>
        </div>
        <div className='col-auto px-0 d-none d-lg-flex flex-column align-items-end'>
          <h4
            className='ProximaNova-Bold text-nowrap text-primary mb-0'>{`${currency} ${roundCurrency(price)}`}</h4>
          <p className='small'>Qty: {quantity}</p>
        </div>
      </div>
      {
        trackingStatus && !isDesignService && !isEphotobookStandalone &&
        <div className='d-none d-lg-flex container my-4 justify-content-around'>
          {progresses.map((progress, index) => <Progress
            key={`${progress}-${index}`}
            text={progress}
            completed={(index <= completedIndex)}
          />)}
          <a
            href={trackingUrl}
            target="_blank"
            className={`btn btn-outline-primary btn-sm mx-1 ${isTrackButtonEnabled ? '' : 'disabled'}`}
            role="button">Track
          </a>
        </div>
      }
      {
        isDesignService &&
        <div className='d-none d-lg-flex container my-4 justify-content-around'>
          {designServiceProgresses.map((progress, index) => <Progress
            key={`${progress}-${index}`}
            text={progress}
            completed={(index <= dsCompletedIndex)}
            displayStatusLine={index < (designServiceProgresses.length - 1)}
          />)}
        </div>
      }
      {
        isEphotobookStandalone &&
        <div className='d-none d-lg-flex container my-4 justify-content-around'>
          {ephotobookStandaloneProgresses.map((progress, index) => <Progress
            key={`${progress}-${index}`}
            text={progress}
            completed={(index <= ephotobookStandaloneCompletedIndex)}
            displayStatusLine={index < (ephotobookStandaloneProgresses.length - 1)}
          />)}
        </div>
      }
    </div>
  );
};

const Description = (props) => {
  const {
    name = 'Bali Mug',
    product = '',
    platform = '',
    currency = '',
    voucher = '',
    price = '',
    quantity = '',
    type = '',
  } = props;

  return (['projects', 'taopixProject'].includes(type))
    ? (
      <div className='container px-0'>
        <h4 className='ProximaNova-Bold text-center text-lg-left mb-2'>{name}</h4>
        <Line title='Product:' content={product}/>
        <Line title='Platform:' content={platform}/>
        <Line className='row d-lg-none' title='Price:' content={`${currency} ${price}`}/>
        <Line className='row d-lg-none' title='Quantity:' content={quantity}/>
        <Line title='Voucher:' content={<span className='text-secondary'>{voucher || '-'}</span>}/>
      </div>
    )
    : null;
};

const Line = (props) => {
  const { className = 'row' } = props;
  return (
    <div className={className}>
      <div className='col-4 text-nowrap'>{props.title}</div>
      <div className=''>{props.content}</div>
    </div>
  );
};

export default OrderItemProject;



// WEBPACK FOOTER //
// ./src/Account/Order/OrderItem/OrderItemProject.js